/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown>, total: NonNullable<unknown> }} Settings_Template_Topic_Drag_OverInputs */



/**
* | output |
* | --- |
* | "Topic is now in position {position} of {total}." |
*
* @param {Settings_Template_Topic_Drag_OverInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_topic_drag_over = /** @type {((inputs: Settings_Template_Topic_Drag_OverInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Topic_Drag_OverInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Onderwerp staat nu op plaats ${i?.position} van ${i?.total}.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le sujet est maintenant en position ${i?.position} sur ${i?.total}.`)
	return /** @type {LocalizedString} */ (`Topic is now in position ${i?.position} of ${i?.total}.`)
});